<template>
    <section>
      <div class="container my-5"  data-aos="fade-up" data-aos-duration="3000">
        <div class="row p-4 pb-0 pe-lg-0 pt-lg-5 align-items-center rounded-3 border shadow-lg">
          <div class="col-lg-7 p-3 p-lg-5 pt-lg-3">
            <h2 class="display-5 fw-bold">About</h2>
            <p class="lead">
              Starting a business is tough enough without technical glitches or paperwork nightmares. You need a partner who understands your challenges and is there to support you every step of the way.<br>
              Highlight the convenience of offering both web development and business registration services under one roof. Process to save clients money, time and effort.<br>
              •	15+ Years in IT Consultation, Web Development and Windows Application System Projects.<br>
              •	10+ Years in Goods Exportation under GSP, FTA, Trade Facilitation and Business Registration.
            </p>
          </div>
          <div class="col-lg-4 offset-lg-1 p-0 overflow-hidden shadow-lg">
              <img class="rounded-lg-3 border border-secondary aboutme"  src="@/images/it_solution.png" alt="" width="100%">
          </div>
        </div>
      </div>
    </section>
</template>